export const Types = {
  // For copy & paste
  // _REQUEST: '@filters/_REQUEST',
  // _SUCCESS: '@filters/_SUCCESS',
  // _FAILURE: '@filters/_FAILURE',

  GET_CLUBS_REQUEST: '@filters/GET_CLUBS_REQUEST',
  GET_CLUBS_SUCCESS: '@filters/GET_CLUBS_SUCCESS',
  GET_CLUBS_FAILURE: '@filters/GET_CLUBS_SUCCESS',

  GET_COMPETITIONS_REQUEST: '@filters/GET_COMPETITIONS_REQUEST',
  GET_COMPETITIONS_SUCCESS: '@filters/GET_COMPETITIONS_SUCCESS',
  GET_COMPETITIONS_FAILURE: '@filters/GET_COMPETITIONS_FAILURE',

  GET_SEASONS_REQUEST: '@filters/GET_SEASONS_REQUEST',
  GET_SEASONS_SUCCESS: '@filters/GET_SEASONS_SUCCESS',
  GET_SEASONS_FAILURE: '@filters/GET_SEASONS_FAILURE',

  GET_DATES_REQUEST: '@filters/GET_DATES_REQUEST',
  GET_DATES_SUCCESS: '@filters/GET_DATES_SUCCESS',
  GET_DATES_FAILURE: '@filters/GET_DATES_FAILURE',

  GET_STADIUMS_REQUEST: '@filters/GET_STADIUM_REQUEST',
  GET_STADIUMS_SUCCESS: '@filters/GET_STADIUM_SUCCESS',
  GET_STADIUMS_FAILURE: '@filters/GET_STADIUM_FAILURE',

  GET_CAROUSEL_DATES_REQUEST: '@filters/GET_CAROUSEL_DATES_REQUEST',
  GET_CAROUSEL_DATES_SUCCESS: '@filters/GET_CAROUSEL_DATES_SUCCESS',
  GET_CAROUSEL_DATES_FAILURE: '@filters/GET_CAROUSEL_DATES_FAILURE',
};

// CLUBS
export const getClubFiltersRequest = query => ({
  type: Types.GET_CLUBS_REQUEST,
  payload: {
    query,
  },
});

export const getClubFiltersSuccess = filters => ({
  type: Types.GET_CLUBS_SUCCESS,
  payload: {
    filters,
  },
});

export const getClubFiltersFailure = () => ({
  type: Types.GET_CLUBS_FAILURE,
});

// COMPETITIONS
export const getCompetitionFiltersRequest = query => ({
  type: Types.GET_COMPETITIONS_REQUEST,
  payload: {
    query,
  },
});

export const getCompetitionFiltersSuccess = filters => ({
  type: Types.GET_COMPETITIONS_SUCCESS,
  payload: {
    filters,
  },
});

export const getCompetitionFiltersFailure = () => ({
  type: Types.GET_COMPETITIONS_FAILURE,
});

// SEASONS
export const getSeasonFiltersRequest = query => ({
  type: Types.GET_SEASONS_REQUEST,
  payload: {
    query,
  },
});

export const getSeasonFiltersSuccess = filters => ({
  type: Types.GET_SEASONS_SUCCESS,
  payload: {
    filters,
  },
});

export const getSeasonFiltersFailure = () => ({
  type: Types.GET_SEASONS_FAILURE,
});

// DATES
export const getDateFiltersRequest = query => ({
  type: Types.GET_DATES_REQUEST,
  payload: {
    query,
  },
});

export const getDateFiltersSuccess = filters => ({
  type: Types.GET_DATES_SUCCESS,
  payload: {
    filters,
  },
});

export const getDateFiltersFailure = () => ({
  type: Types.GET_DATES_FAILURE,
});

// STADIUMS
export const getStadiumFiltersRequest = query => ({
  type: Types.GET_STADIUMS_REQUEST,
  payload: {
    query,
  },
});

export const getStadiumFiltersSuccess = filters => ({
  type: Types.GET_STADIUMS_SUCCESS,
  payload: {
    filters,
  },
});

export const getStadiumFiltersFailure = () => ({
  type: Types.GET_STADIUMS_FAILURE,
});

// CAROUSEL DATES
export const getCarouselDatesFiltersRequest = query => ({
  type: Types.GET_CAROUSEL_DATES_REQUEST,
  payload: {
    query,
  },
});

export const getCarouselDatesFiltersSuccess = filters => ({
  type: Types.GET_CAROUSEL_DATES_SUCCESS,
  payload: {
    filters,
  },
});

export const getCarouselDatesFiltersFailure = () => ({
  type: Types.GET_CAROUSEL_DATES_FAILURE,
});
